import {
  mapCustomIntermediatePointToFormValues,
  mapCustomsControlToFormValues,
  mapDeliveryPointToFormValues,
  mapFerryPassageToFormValues,
  OrderPointType
} from './OrderForm'
import {
  findIntermediatePointsByPrecedingDeliveryPoint,
  findIntermediatePointsPriorFirstLoading
} from 'components/Order/utils'
import { DeliveryPointType, IntermediatePointType } from 'components/Order/constants'

export function orderFormPointsOf (loadingDeliveryPoints, unloadingDeliveryPoints, intermediatePoints, ferryServices) {
  const points = []

  const mapIntermediatePointToFormValues = ip => {
    if (ip.type === IntermediatePointType.FerryPassage) {
      const ferryService = ferryServices.find(service => service.id === ip.ferryServiceId)
      return mapFerryPassageToFormValues(ip, ferryService)
    }
    if (ip.type === IntermediatePointType.CustomsControl) {
      return mapCustomsControlToFormValues(ip)
    }
    if (ip.type === IntermediatePointType.Custom) {
      return mapCustomIntermediatePointToFormValues(ip)
    }
    throw new Error('Unknown intermediate point type')
  }

  findIntermediatePointsPriorFirstLoading(intermediatePoints)
    .map(mapIntermediatePointToFormValues)
    .forEach(p => points.push(p))

  loadingDeliveryPoints.forEach((dp, i) => {
    points.push(mapDeliveryPointToFormValues(dp, OrderPointType.Loading))
    findIntermediatePointsByPrecedingDeliveryPoint(intermediatePoints, i + 1, DeliveryPointType.Loading)
      .map(mapIntermediatePointToFormValues)
      .forEach(p => points.push(p))
  })

  unloadingDeliveryPoints.forEach((dp, i) => {
    points.push(mapDeliveryPointToFormValues(dp, OrderPointType.Unloading))
    findIntermediatePointsByPrecedingDeliveryPoint(intermediatePoints, i + 1, DeliveryPointType.Unloading)
      .map(mapIntermediatePointToFormValues)
      .forEach(p => points.push(p))
  })

  return points
}
